import { useEffect, useState } from "react";

const SUGGESTIONS = [
  " Is this influencer suitable for a North India campaign?",
  " Is this influencer good for lifestyle brands?",
  " Does this profile have gender-specific reach?",
  " Is this influencer suitable for fashion campaigns?",
  " Can this influencer target metro cities?"
].filter(Boolean);

export function useRotatingPlaceholder(
  isTyping: boolean,
  interval = 5000
) {
  const [index, setIndex] = useState(0);
  const [placeholder, setPlaceholder] = useState(SUGGESTIONS[0]);

  useEffect(() => {
    if (isTyping) return; // ❌ stop when user types

    const timer = setInterval(() => {
      setIndex((prev) => {
        const next = (prev + 1) % SUGGESTIONS.length;
        setPlaceholder(SUGGESTIONS[next]);
        return next;
      });
    }, interval);

    return () => clearInterval(timer);
  }, [isTyping, interval]);

  return placeholder;
}